<template>
  <div>
    <v-calendar
      v-show="showDatePicker"
      :attributes="attrs"
      :min-date="cx_current_date"
      title-position="left"
      :disabled-dates="cx_disabled_dates"
      :locale="cx_locale"
      v-on:dayclick="onDayClick"
    >
      <template #footer>
        <div class="legend">
          <span class="today">Hoje</span>
          <span class="selected">Data selecionada</span>
        </div>
      </template>
    </v-calendar>
  </div>
</template>

<script>
import DatePicker from "@/components/Util/DatePicker/DatePicker";
export default DatePicker;
</script>

<style lang="scss">
@import "DatePicker.scss";
</style>
